var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVatransportation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#667085",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M8.872 1.406a1.241 1.241 0 0 1 1.79 1.721l-1.39 1.455c-.108.114-.163.171-.196.238a.5.5 0 0 0-.052.19c-.005.074.012.15.048.305l.864 3.743c.036.158.054.237.049.313a.5.5 0 0 1-.056.193c-.035.068-.093.125-.207.24l-.185.185c-.303.303-.455.455-.61.482a.5.5 0 0 1-.385-.09c-.127-.095-.195-.298-.33-.704L7.207 6.662 5.534 8.335c-.1.1-.15.15-.183.208a.5.5 0 0 0-.059.168c-.01.067-.003.137.013.278l.092.826c.015.14.023.21.013.278a.5.5 0 0 1-.06.168 1.033 1.033 0 0 1-.183.208l-.098.1c-.237.236-.355.354-.487.388a.5.5 0 0 1-.344-.034c-.122-.06-.215-.198-.4-.477L3.052 9.27a.943.943 0 0 0-.069-.097.501.501 0 0 0-.056-.056c-.022-.02-.047-.036-.097-.069l-1.176-.784c-.278-.186-.417-.278-.477-.4a.5.5 0 0 1-.034-.345c.034-.132.153-.25.39-.486l.098-.1c.1-.099.15-.149.208-.182a.5.5 0 0 1 .169-.06c.066-.01.137-.002.277.013l.827.092c.14.016.21.024.277.013a.5.5 0 0 0 .168-.059c.059-.033.109-.083.209-.183l1.672-1.673L2.425 3.89c-.407-.135-.61-.203-.704-.33a.5.5 0 0 1-.091-.385c.027-.155.179-.306.482-.61l.185-.185c.115-.114.172-.171.24-.207a.5.5 0 0 1 .193-.055c.076-.006.155.012.313.048l3.73.861c.154.036.232.054.307.048a.5.5 0 0 0 .206-.06c.065-.037.12-.094.231-.208l1.355-1.4Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h12v12H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVatransportation);
export default __webpack_public_path__ + "static/media/vatransportation.bc2b5f090f1a75de077ab4dd7601fc20.svg";
export { ForwardRef as ReactComponent };